import { FormikContextType } from 'formik';
import { BidSheetRow } from '../../../hooks/useBidSheetState';

const recalculateBid = (context: FormikContextType<BidSheetRow>) => {
  const { values: bid, setValues } = context;

  const subTotal = bid.volume * bid.bidPrice;

  // Strike Price for Credits Purchase through Down Payment
  const discountedBidPrice = bid.bidPrice * (1 - bid.discount / 100);

  const cappedDPThreshold = Math.round(bid.downPayment / discountedBidPrice);
  const cappedDPAmount = cappedDPThreshold > bid.volume ? discountedBidPrice * bid.volume : bid.downPayment;

  // Credits Purchased at Discount Price Using Down Payment
  const downPaymentCreditsAtDiscount = Math.round(cappedDPAmount / discountedBidPrice);

  const nonDiscountedCredits = bid.volume - downPaymentCreditsAtDiscount;
  const total = nonDiscountedCredits * bid.bidPrice + downPaymentCreditsAtDiscount * discountedBidPrice;
  const averagePrice = total / bid.volume;

  const recalculatedBid = {
    ...bid,
    discountedCredits: downPaymentCreditsAtDiscount,
    subTotal,
    total,
    averagePrice,
  } as const;

  setValues(recalculatedBid);
};

recalculateBid.keys = ['volume', 'bidPrice', 'downPayment', 'discount'] as (keyof BidSheetRow)[];

const useFormChangeWatcher = () => recalculateBid;

export default useFormChangeWatcher;
